export default __webpack_public_path__ + "static/media/brown.67b0a604.jpg";